import { QueryHandler } from '@/redux/types/query-handler';
import { dispatchOptimisticPatchUpdateOrganisation } from './dispatch-optimistic-patch';
import { UpdateOrganisationQueryArg } from '../types/query-arg';

export const handleResultUpdateOrganisation: QueryHandler<
  UpdateOrganisationQueryArg,
  void
> = async (queryArg, { dispatch, getState, queryFulfilled }) => {
  const { patch } = dispatchOptimisticPatchUpdateOrganisation(queryArg, {
    dispatch,
    getState,
  });

  try {
    await queryFulfilled;
  } catch (err) {
    patch.undo();
    throw err;
  }
};
